export default {
  GET_GROUPS: (state) => state.groups,
  GET_ACTIVE_GROUPS: (state) => state.groups.filter((group) => group.status),
  GET_GROUP: (state) => state.group,
};
